import api, { handleApiError } from './client';

export const emailTemplateService = {
  getEmailTemplates: async () => {
    try {
      const response = await api.get('/api/email-templates');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get email templates error:', error);
      return {
        success: false,
        message: handleApiError(error, 'Errore di connessione al server')
      };
    }
  },

  createEmailTemplate: async (name, subject, body) => {
    try {
      const response = await api.post('/api/email-templates', { name, subject, body });
      return response.data;
    } catch (error) {
      console.error('Create email template error:', error);
      return {
        success: false,
        message: handleApiError(error, 'Errore di connessione al server')
      };
    }
  },

  updateEmailTemplate: async (id, name, subject, body) => {
    try {
      const response = await api.put(`/api/email-templates/${id}`, { name, subject, body });
      return response.data;
    } catch (error) {
      console.error('Update email template error:', error);
      return {
        success: false,
        message: handleApiError(error, 'Errore di connessione al server')
      };
    }
  },

  deleteEmailTemplate: async (id) => {
    try {
      const response = await api.delete(`/api/email-templates/${id}`);
      return response.data;
    } catch (error) {
      console.error('Delete email template error:', error);
      return {
        success: false,
        message: handleApiError(error, 'Errore di connessione al server')
      };
    }
  }
};

export default emailTemplateService;
